module.exports = __webpack_public_path__ + "media/bg.90dc65ef.mp4";